import script from "./error.vue?vue&type=script&setup=true&lang=js"
export * from "./error.vue?vue&type=script&setup=true&lang=js"

import "./error.vue?vue&type=style&index=0&id=50761c55&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50761c55"]])

export default __exports__